import { z } from 'zod';
import { emailSchema, isoTimestamp, roleSchema } from './common';

export const memberDtoSchema = z.object({
  userId: z.uuid(),
  email: z.string(),
  name: z.string(),
  role: roleSchema,
  joinedAt: isoTimestamp,
});
export type MemberDto = z.infer<typeof memberDtoSchema>;

export const inviteMemberRequestSchema = z.object({ email: emailSchema, role: roleSchema });
export type InviteMemberRequest = z.infer<typeof inviteMemberRequestSchema>;

export const updateMemberRequestSchema = z.object({ role: roleSchema });

export const invitationPreviewSchema = z.object({
  email: z.string(),
  tenantName: z.string(),
  role: roleSchema,
  userExists: z.boolean(),
});
export type InvitationPreview = z.infer<typeof invitationPreviewSchema>;

export const invitationTokenSchema = z.string().min(20).max(200);

export const acceptInvitationRequestSchema = z.object({
  token: invitationTokenSchema,
  name: z.string().trim().min(1).max(100).optional(),
  password: z.string().min(1, 'Password is required').max(256),
});
export type AcceptInvitationRequest = z.infer<typeof acceptInvitationRequestSchema>;
